import { Empty, Pagination, Spin } from "antd";
import { AlertCircle } from "lucide-react";
import { FC } from "react";
import { BookingItem } from "./booking-item";

interface BookingListProps {
  isLoading: boolean;
  bookings: any[];
  filters: any;
  setFilters: (filters: any) => void;
  totalItems: number;
}

export const BookingList: FC<BookingListProps> = ({
  isLoading,
  bookings,
  filters,
  setFilters,
  totalItems,
}) => {
  return (
    <div className="bg-white border border-[#e5e5e5] overflow-hidden">
      {/* Table Header */}
      <div className="bg-[#f5f5f5] p-4 border-b border-[#e5e5e5]">
        <div className="grid grid-cols-12 gap-4 text-xs font-bold uppercase tracking-widest text-[#999]" style={{ fontFamily: "'Montserrat', sans-serif" }}>
          <div className="col-span-2">ID</div>
          <div className="col-span-3">Client</div>
          <div className="col-span-2">Project</div>
          <div className="col-span-1">Date</div>
          <div className="col-span-1">Status</div>
          <div className="col-span-1">Amount</div>
          <div className="col-span-2">Actions</div>
        </div>
      </div>

      {/* Table Body */}
      {isLoading ? (<Spin size="large" className="p-8 flex justify-center items-center h-[55vh] w-full" />) : bookings.length > 0 ? (
        <div className="divide-y divide-[#e5e5e5]">
          {bookings.map((booking) => (
            <BookingItem key={booking.id} booking={booking} />
          ))}
        </div>
      ) : (
        <div className="p-8 text-center">
          <Empty
            image={
              <AlertCircle size={40} className="mx-auto text-[#d9d9d9]" />
            }
            description={
              <div>
                <h3 className="text-sm font-bold uppercase tracking-wide text-[#1a1a2e]" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                  No bookings found
                </h3>
                <p className="text-xs text-[#999] mt-1" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                  Try adjusting your search or filter criteria
                </p>
              </div>
            }
          />
        </div>
      )}

      {/* Pagination */}
      {totalItems > 0 && (
        <div className="p-4 border-t border-[#e5e5e5] bg-[#f5f5f5] flex justify-between items-center">
          <div className="text-xs font-bold uppercase tracking-wide text-[#999]" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Showing {bookings.length} of {totalItems} bookings
          </div>
          <Pagination
            total={totalItems}
            current={filters?.page}
            onChange={(page) => setFilters({ ...filters, page })}
            showSizeChanger={false}
          />
        </div>
      )}
    </div>
  );
};
